module.exports = __webpack_public_path__ + "img/head.5d953ef8.png";